import axios from "axios";
import { trim } from "lodash";
import React, { useEffect, useState } from "react";
import NavDropdown from "react-bootstrap/NavDropdown";
import { AiOutlineDelete } from "react-icons/ai";
import { BsArrowLeft } from "react-icons/bs";
import { FaPen } from "react-icons/fa";
import { GoKebabVertical } from "react-icons/go";
import { Link, useNavigate } from "react-router-dom";
import validator from "validator";
import Loader from "../Components/Global/Loader";
import DashboardLayouts from "../Components/Layout/DashboardLayouts";
import { useAuth } from "../Context/AuthContext";
import useAxiosFetch from "../hooks/useAxiosFetch";
import useStateProvince from "../hooks/useStateProvince";
import useToastify from "../hooks/useToastify";
import DummyImg from "../Public/Images/568165.png";

function Addmanager() {
  const { userRole, userDetails, designation, setUserDetails } = useAuth();
    // show toast hook 
  const { notify } = useToastify();;
  const route = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [errorMessage, setErrorMessage] = useState();
  // api api from global hook 

  const { axiosFetch} = useAxiosFetch();

  // get country province from hook

  const [countryList, stateList, getProvinceFunc] = useStateProvince();

  const {
    building_id,
    first_name,
    middle_name,
    last_name,
    username,
    email,
    phone_number,
    address,
    apartment,
    city,
    province,
    country,
    postal_code,
    profile_image,
    payment_details,
    company_name,
  } = userDetails;

  useEffect(() => {
    if (country) {
      getProvinceFunc(country);
    }
  }, [country]);

  //Validation for inputs

  const validation = () => {
    const errors = {};
    if (!phone_number || !trim(phone_number)) {
      errors.phone_number = "Please enter your phone number.";
    } else if (!validator.isMobilePhone(phone_number)) {
      errors.phone_number = "Please enter a valid phone number.";
    }
    return errors;
  };
  //State update 


  const handleData = (e) => {
    const { value } = e.target;
    setUserDetails({ ...userDetails, [e.target.name]: value });
    if (e.target.name === "profile_image") {
      let file = e.target.files[0];
      const fileSize = file.size / 1024 / 1024; // in MiB
      if (fileSize > 2) {
        notify("File size has exceeded it max limit of 2MB.", "error");
        return;
      } else {
        setUserDetails({
          ...userDetails,
          profile_image: { url: URL.createObjectURL(file), file: file },
        });
      }
    }
    setErrorMessage("");
  };

  //Api call to update user details with image

  const SubmitHandler = (e) => {
    e.preventDefault();
    const Valid = validation();

    if (Valid && Object.keys(Valid)?.length === 0) {
      setErrorMessage("");
      setLoading(true);

      if (userDetails?.profile_image?.file) {
        const formdata = new FormData();
        formdata.append("image", userDetails?.profile_image?.file);
        axios
          .post("/global/fileupload", formdata, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            const createdata = {
              ...userDetails,
              phone_number: parseInt(phone_number),
              profile_image: res?.data?.links[0],
            };

            submitData(createdata);
          })
          .catch((err) => {
            setLoading(false);

     
            if(err?.response){

              notify(err?.response?.data?.message, "error");
            }else{
              notify(`The file you are trying to upload is too large`, "error");
            }
          });
      } else {
        submitData(userDetails);
      }
    } else {
      setErrorMessage(Valid);
    }
  };

  //Api call to update user details

  const submitData = (createdata) => {
    axiosFetch({
      axiosInstance: axios,
      method: "POST",
      url: `/update/${userDetails.id}`,

      requestConfig: createdata,
    })
      .then((res) => {
        setLoading(false);

        if (userRole == "Owner" || userRole == "Partner") {
          route("/dashboard", { state: { reload: 1 } });
        } else if (userRole == "Tenant") {
          route("/tenantdashboard");
        } else if (userRole == "Worker") {
          route("/workerdashboard");
        } else if (userRole == "Manager") {
          route("/managerdashboard");
        } else {
          route("/admindashboard");
        }

        if (res.status === 201) {
          setError(res?.data?.errMsg);
        }
      })
      .catch(function (error) {
        setLoading(false);
        setError(error?.data?.errMsg);
      });
  };

  return (
    <>
      <DashboardLayouts>
        {loading && <Loader />}

        {/* --- Section Heading ---- */}
        <div className="d-flex ">
          <Link
            to={
              userRole === "Owner" || userRole === "Partner"
                ? "/dashboard"
                : `/${userRole}dashboard`.toLowerCase()
            }
            className="back-link back_to_login justify-content-center"
          >
            <BsArrowLeft className="me-2 back-arrow m-0 " color="#0064BB" />
            <h3 className="mb-0">Back To Dashboard</h3>
          </Link>
        </div>
        <div className="breadcrumb justify-content-center personal-page-heading">
          Personal Info
        </div>
        {/* ----- Body Content ---- */}

        <form action="" className="dash-form add-form add-building-area">
          <div className="row pt-2 pt-md-5">
            <div className="col-md details-area">
              <div className="row gy-1 gy-md-4">
                <div className="col-xl-4 col-xxl-3 col-md-6 mb-2">
                  <div className="form-group">
                    <label htmlFor="" className="form-lbl">
                      First Name
                    </label>
                    <input
                      onChange={(e) => handleData(e)}
                      type="text"
                      readOnly={first_name}
                      value={first_name}
                      name="first_name"
                      id="first_name"
                      className={`form-control form-g1`}
                      placeholder={`First Name`}
                    />
                  </div>
                </div>

                <div className="col-xl-4 col-xxl-3 col-md-6 mb-2">
                  <div className="form-group">
                    <label htmlFor="" className="form-lbl">
                      Middle Name
                    </label>
                    <input
                      onChange={(e) => handleData(e)}
                      type="text"
                      value={middle_name}
                      readOnly={true}
                      name="middle_name"
                      id="middle_name"
                      className={`form-control form-g1`}
                      placeholder={`Middle Name`}
                    />
                  </div>
                </div>
                <div className="col-xl-4 col-xxl-3 col-md-6 mb-2">
                  <div className="form-group">
                    <label htmlFor="" className="form-lbl">
                      Last Name
                    </label>
                    <input
                      onChange={(e) => handleData(e)}
                      type="text"
                      value={last_name}
                      readOnly={last_name}
                      name="last_name"
                      id="last_name"
                      className={`form-control form-g1`}
                      placeholder={`Last Name`}
                    />
                  </div>
                </div>

                <div className="col-xl-4 col-xxl-3 col-md-6 mb-2">
                  <div className="form-group">
                    <label htmlFor="" className="form-lbl">
                      Username
                    </label>
                    <input
                      onChange={(e) => handleData(e)}
                      type="text"
                      value={username}
                      readOnly={username}
                      name="username"
                      id="username"
                      className={`form-control form-g1`}
                      placeholder={`username`}
                    />
                  </div>
                </div>

                <div className="col-xl-4 col-xxl-3 col-md-6 mb-2">
                  <div className="form-group">
                    <label htmlFor="" className="form-lbl">
                      Email Id
                    </label>
                    <input
                      onChange={(e) => handleData(e)}
                      type="text"
                      value={email}
                      readOnly={designation !== "Owner"}
                      name="email"
                      className={`form-control form-g1`}
                      placeholder={`Email`}
                    />
                    {errorMessage?.email ? (
                      <div
                        className="error error-message"
                        style={{ color: "red" }}
                      >
                        {errorMessage?.email}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex col-md-auto justify-content-center justify-content-lg-start justify-content-xl-end image-parent">
              <div className="personal_details_profile_image position-relative">
                <img
                  src={
                    profile_image
                      ? profile_image?.url
                        ? profile_image?.url
                        : profile_image
                      : DummyImg
                  }
                  alt=""
                  className="p-3"
                />
                <div className="img-upload">
                  <NavDropdown
                    title={
                      <label>
                        <GoKebabVertical className="edit-pen" color="black" />
                      </label>
                    }
                    className={"user-profile-link-image"}
                  >
                    <NavDropdown.Item href="#action/3.2">
                      <label
                        htmlFor="profile_image"
                        className="user-list d-flex align-items-center"
                      >
                        <FaPen className="user-i" /> Image upload
                      </label>
                      <input
                        type="file"
                        className="form-control d-none"
                        id="profile_image"
                        name="profile_image"
                        onChange={(e) => handleData(e)}
                      />
                    </NavDropdown.Item>

                    <NavDropdown.Item
                      onClick={(e) =>
                        setUserDetails({ ...userDetails, profile_image: "" })
                      }
                    >
                      <button className="user-list d-flex align-items-center">
                        <AiOutlineDelete className="user-i" />
                        Remove image
                      </button>
                    </NavDropdown.Item>
                  </NavDropdown>
                </div>
              </div>
            </div>
          </div>
          <div className="row personal_living_details">
            <div className="col-xl-auto col-md-6 mb-2 mt-1 mt-md-4">
              <div className="form-group">
                <label htmlFor="" className="form-lbl">
                  Phone Number
                </label>
                <input
                  onChange={(e) => handleData(e)}
                  type="text"
                  value={phone_number}
                  name="phone_number"
                  className={`form-control form-g1`}
                  placeholder={`Phone Number`}
                />
                {errorMessage?.phone_number ? (
                  <div className="error error-message" style={{ color: "red" }}>
                    {errorMessage?.phone_number}
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="col-xl-auto col-md-6 mb-2 mt-1 mt-md-4">
              <div className="form-group">
                <label htmlFor="" className="form-lbl">
                  Country
                </label>
                <select
                  value={country}
                  name="country"
                  onChange={(e) => handleData(e)}
                  className={`form-control form-g1`}
                  placeholder={`Country`}
                >
                  <option value="">Choose Country</option>
                  {countryList?.map((items, i) => {
                    return (
                      <option key={i} value={items.id}>
                        {items.country_name}
                      </option>
                    );
                  })}
                </select>
                {errorMessage?.country ? (
                  <div className="error error-message" style={{ color: "red" }}>
                    {errorMessage?.country}
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="col-xl-auto col-md-6 mb-2 mt-1 mt-md-4">
              <div className="form-group">
                <label htmlFor="" className="form-lbl">
                  Province
                </label>
                <select
                  value={province}
                  name="province"
                  onChange={(e) => handleData(e)}
                  className={`form-control form-g1 `}
                  placeholder={`Province`}
                >
                  <option value="">Choose Province</option>
                  {stateList?.map((items, i) => {
                    return (
                      <option key={i} value={items.id}>
                        {items.province_name}
                      </option>
                    );
                  })}
                </select>
                {errorMessage?.province ? (
                  <div className="error error-message" style={{ color: "red" }}>
                    {errorMessage?.province}
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>

            <div className="col-xl-auto col-md-6 mb-2 mt-1 mt-md-4">
              <div className="form-group">
                <label htmlFor="" className="form-lbl">
                  City
                </label>
                <input
                  onChange={(e) => handleData(e)}
                  type="text"
                  value={city}
                  name="city"
                  className={`form-control form-g1`}
                  placeholder={`City`}
                />
              </div>
            </div>

            <div className="col-xl-auto col-md-6 mb-2 mt-1 mt-md-4">
              <div className="form-group">
                <label htmlFor="" className="form-lbl">
                  Postal Code
                </label>
                <input
                  onChange={(e) => handleData(e)}
                  type="text"
                  value={postal_code}
                  name="postal_code"
                  className={`form-control form-g1`}
                  placeholder={`Postal Code`}
                />
              </div>
            </div>
            <div className="col-xl-auto col-md-6 mb-2 mt-1 mt-md-4">
              <div className="form-group">
                <label htmlFor="" className="form-lbl">
                  Apartment
                </label>
                <input
                  onChange={(e) => handleData(e)}
                  type="text"
                  value={apartment}
                  name="apartment"
                  className={`form-control form-g1`}
                  placeholder={`Apartment`}
                />
              </div>
            </div>
            <div className="col-xl-auto col-md-6 mb-2 mt-1 mt-md-4">
              <div className="form-group">
                <label htmlFor="" className="form-lbl">
                  Street Address
                </label>
                <input
                  onChange={(e) => handleData(e)}
                  type="text"
                  value={address}
                  name="address"
                  className={`form-control form-g1`}
                  placeholder={`Address`}
                />
              </div>
            </div>
            {userRole == "Owner" && (
              <>
                <div className="col-xl-auto col-md-6 mb-2 mt-1 mt-md-4">
                  <div className="form-group">
                    <label htmlFor="" className="form-lbl">
                      Company name
                    </label>
                    <input
                      onChange={(e) => handleData(e)}
                      type="text"
                      value={company_name}
                      name="company_name"
                      className={`form-control form-g1`}
                      placeholder={` Company name`}
                    />
                  </div>
                </div>
                <div className="col-xl-auto col-md-6 mb-2 mt-1 mt-md-4">
                  <div className="form-group">
                    <label htmlFor="" className="form-lbl">
                      Payment details
                    </label>
                    <input
                      onChange={(e) => handleData(e)}
                      type="text"
                      value={payment_details}
                      name="payment_details"
                      className={`form-control form-g1`}
                      placeholder={`Payment details`}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="col-md-6 col-xl-12 mt-2 mt-lg-5 col-md-6">
            <button
              type="submit"
              className="btn btn-primary btn-lg form-btn add-building-btn"
              onClick={(e) => {
                SubmitHandler(e);
              }}
            >
              Submit
            </button>
          </div>
        </form>
      </DashboardLayouts>
    </>
  );
}
export default Addmanager;
